import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import { useFormState, useForm } from 'react-final-form';
import { createFilterOptions } from '@material-ui/lab/useAutocomplete';
import QCXAutocompleteSelect from '../../../shared-components/autocomplete-select/QCXAutocompleteSelect' // lista suspensa

export default function ModelosLpcosOrgaoField({
    metadado, 
    listaModelos,
    isConsult,
    basePath="",
    ...restProps

}) {

    const [obrigatorio, setObrigatorio] = useState(false);
    const [listValores, setListValores] = useState([]);
    const [defaultValue, setDefaultValue] = useState('');


    const filterOptions = createFilterOptions({
        stringify: (item) => `${item.codigo} - ${item.value}`,
    });


    useEffect(() => {
      if (listaModelos) {
        setListValores([...listaModelos].map(el => ({
            id: el.codigo,
            value: `${el.codigo} - ${el.nome}`,
        })))

        setDefaultValue({ id: null, value: '' });
      }

    }, [listaModelos])


    return (
        <>
          <QCXAutocompleteSelect
            label="Modelos LPCO por Órgão Anuente"
            id="atributosAdicionais.lpcoForm.modeloCode"
            name="atributosAdicionais.lpcoForm.modeloCode"
            options={listValores}
            filterOptions={filterOptions}
            defaultValue={defaultValue}
            getOptionLabel={(item) => (
                item.value ? item.value : ''
            )}
            required={obrigatorio}
            isConsult={isConsult}
            disabled={isConsult}
            {...restProps}
          />
        </>
    )
    
    

}
